import { createContext } from 'react';

export const TranslationsContext = createContext({});
